/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, StreamAnalysisGetVideoAnalysisStationSettingsPathParams, StreamAnalysisGetVideoAnalysisStationSettings401, StreamAnalysisGetVideoAnalysisStationSettings403 } from "../models/StreamAnalysisGetVideoAnalysisStationSettings";

export function getStreamAnalysisGetVideoAnalysisStationSettingsUrl(entityId: StreamAnalysisGetVideoAnalysisStationSettingsPathParams["entityId"]) {
  const res = { method: 'GET', url: `/stream-analysis/v1/video-analysis/station-settings/${entityId}` as const }
  return res
}

/**
 * @description Every setting is resolved to its effective value, taking the station's own value when present, then the inherited value, then the built-in default. Only settings available to API clients are included.
 * @summary Get the effective settings of a station
 * {@link /stream-analysis/v1/video-analysis/station-settings/:entityId}
 */
export async function streamAnalysisGetVideoAnalysisStationSettings(entityId: StreamAnalysisGetVideoAnalysisStationSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, ResponseErrorConfig<StreamAnalysisGetVideoAnalysisStationSettings401 | StreamAnalysisGetVideoAnalysisStationSettings403>, unknown>({ method : "GET", url : getStreamAnalysisGetVideoAnalysisStationSettingsUrl(entityId).url.toString(), ... requestConfig })
  return res.data
}